// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_3UWQXr9XTYx4ikzq1xmrRA"};